
export class grupoProducto {
    id: number;
    tipo: string;
    idEmisor: number;
    color: string;
    }

    